<template>
  <div>
    <div class="ball-numbers">
      <div
          v-for="(item, index) in numbers"
          :key="index"
          class="ball-numbers__item"
          @click="$emit('handleChosenItem', { number: item.number, type: item.type, key: item.key})"
          :class="{active: item.isActive}"
      >
        <a>{{ item.number }}</a>
      </div>
    </div>
    <div class="ball-numbers__add-line">
      <button @click="$emit('handleAddLine')">ADD LINE</button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    numbers: {
      type: Array,
      default: () => []
    }
  },
  methods: {
  }
}
</script>

<style scoped lang="scss" src="@/assets/scss/common/ball/ball-numbers.scss"/>
